import { useLoadingState, useObjectTranslation } from '@monkvision/common';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import { unparse } from 'papaparse';
import { DashboardInspection } from '../useInspectionList/types';

export interface UseExportToCsvParams {
  inspections: DashboardInspection[];
  currency: string;
}

export function useExportToCsv({ inspections }: UseExportToCsvParams) {
  const { i18n } = useTranslation();
  const { tObj } = useObjectTranslation();
  const loading = useLoadingState();

  const createCsv = useCallback(() => {
    const csvArray: string[][] = [];
    csvArray.push(['VIN', 'Status', 'ID', 'Last Updated', 'Inspection Start', 'Inspection End']);
    inspections.forEach((inspection) => {
      csvArray.push([
        inspection.vin ?? '',
        inspection.status ?? '',
        inspection.inspectionId ?? '',
        inspection.lastUpdated ? dayjs(inspection.lastUpdated).format('YYYY-MM-DD HH:mm:ss') : '',
        inspection.inspectionStart
          ? dayjs(inspection.inspectionStart).format('YYYY-MM-DD HH:mm:ss')
          : '',
        inspection.inspectionEnd
          ? dayjs(inspection.inspectionEnd).format('YYYY-MM-DD HH:mm:ss')
          : '',
      ]);
    });
    return unparse(csvArray);
  }, [inspections, tObj, i18n.language]);

  const exportToCsv = useCallback(() => {
    loading.start();
    const csv = createCsv();
    const blob = new Blob([csv], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = url;
    a.download = 'hagerty_inspections.csv';
    a.click();
    a.remove();
    loading.onSuccess();
  }, [loading, inspections, createCsv]);

  return { exportToCsv, loading };
}
